module.exports = __webpack_public_path__ + "img/global-trading.7bbed524.png";